import MultipleSelect from './src/multiple-select';

export default MultipleSelect;
